/**
 * Grill King — back to top FAB.
 * Same size/UI as Shopify Inbox chat; sits directly above it and slides up from it.
 */
(function () {
  'use strict';

  var SHOW_AFTER = 420;
  var GAP = 10;
  var PHONE_IDLE_HIDE = 2200;
  var btn = null;
  var ticking = false;
  var phone = window.matchMedia('(max-width: 749px)');
  var lastY = window.scrollY;
  var hideTimer = null;

  function ensureButton() {
    if (btn && document.body.contains(btn)) return btn;

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'egj-back-top';
    btn.setAttribute('data-egj-back-top', '');
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path d="M8 12.5V3.5" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>' +
      '<path d="M4.25 7L8 3.25 11.75 7" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    btn.addEventListener('click', function () {
      if (window.gkLenis) {
        window.gkLenis.scrollTo(0, { duration: 1.2 });
        return;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.body.appendChild(btn);
    return btn;
  }

  /* Inbox nests the activator inside more than one shadow root. */
  function deepQuery(root, selector, depth) {
    if (!root || depth > 4) return null;
    var hit = root.querySelector(selector);
    if (hit) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        hit = deepQuery(all[i].shadowRoot, selector, depth + 1);
        if (hit) return hit;
      }
    }
    return null;
  }

  function findChatActivator() {
    var host = document.querySelector('shopify-chat') || document.querySelector('#shopify-chat');
    if (host && host.shadowRoot) {
      var activator =
        deepQuery(host.shadowRoot, 'button.activator', 0) ||
        deepQuery(host.shadowRoot, '[data-testid="chat-button"]', 0);
      if (activator) {
        var r = activator.getBoundingClientRect();
        if (r.width > 20 && r.height > 20) {
          return { rect: r, radius: window.getComputedStyle(activator).borderRadius };
        }
      }
    }

    var iframe = document.querySelector('iframe#dummy-chat-button-iframe');
    if (iframe) {
      var ir = iframe.getBoundingClientRect();
      if (ir.width > 20 && ir.height > 20) return { rect: ir, radius: '' };
    }

    return null;
  }

  function place(el) {
    var chat = findChatActivator();
    if (chat) {
      var r = chat.rect;
      el.style.left = Math.max(0, Math.round(r.left)) + 'px';
      el.style.right = 'auto';
      el.style.bottom = Math.max(0, Math.round(window.innerHeight - r.top + GAP)) + 'px';
      el.style.width = Math.round(r.width) + 'px';
      el.style.height = Math.round(r.height) + 'px';
      el.style.borderRadius = chat.radius;
      return;
    }

    /* Chat not mounted yet: fall back to the CSS geometry in fp-chrome-extras.css */
    el.style.left = el.style.right = el.style.bottom = '';
    el.style.width = el.style.height = el.style.borderRadius = '';
  }

  function update() {
    ticking = false;
    var el = ensureButton();
    var y = window.scrollY;
    var show = y > SHOW_AFTER;
    /* On phones the button sits over body copy at the right edge, so it only
       appears while the visitor is scrolling back up, then gets out of the way. */
    if (phone.matches) {
      show = show && y < lastY;
      window.clearTimeout(hideTimer);
      if (show) hideTimer = window.setTimeout(update, PHONE_IDLE_HIDE);
    }
    lastY = y;
    var visible = el.classList.contains('is-visible');
    if (show && !visible) place(el);
    if (show === visible && el.hasAttribute('aria-hidden')) return;
    el.classList.toggle('is-visible', show);
    el.setAttribute('aria-hidden', show ? 'false' : 'true');
    el.tabIndex = show ? 0 : -1;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function onResize() {
    var el = ensureButton();
    if (el.classList.contains('is-visible')) place(el);
    onScroll();
  }

  function init() {
    ensureButton();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.setTimeout(update, 600);
    window.setTimeout(update, 1600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
